<template>
  <div class="wapper"
       v-if="info != null">
    <div class="content-wapper">
      <div class="approval-wapper">
        <ul>
          <li class="approval-main"
              v-for="item in info.taskDetailList"
              :key="item.id">
            <div class="approval-item">
              <img src="../../assets/approval.png"
                   class="icon">
              <div class="approval-content">
                <span>{{item.selectMethodName}}</span>
                <span class="approval-method"
                      v-if="item.taskDetailList.length > 1">{{item.multiApprovalMethodName}}</span>
                <ul class="approval-detail">
                  <li v-for="detail in item.taskDetailList"
                      :key="detail.id">
                    <img src="../../assets/personal.png"
                         class="avatar">
                    <div>
                      <template v-if="detail.processState == 1">
                        <!-- 指定人 -->
                        <span v-if="item.selectMethod == 1">{{detail.approvalUserName}}</span>
                        <!-- 指定角色 -->
                        <span v-else>{{detail.approvalRoleName}}</span>
                      </template>
                      <template v-else>
                        <!-- 指定人 -->
                        <span v-if="item.selectMethod == 1">{{detail.approvalUserName}}</span>
                        <!-- 指定角色 -->
                        <span v-else>{{detail.operatorName}}·{{detail.approvalRoleName}}</span>
                        <span class="opinion">{{detail.opinion}}</span>
                      </template>
                    </div>
                    <div class="state"
                         v-if="detail.processState != 4 && detail.processState != 5">
                      <span>{{detail.processStateName}}</span>
                      <span class="time">{{detail.processTime}}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _approval from '@/service/approval-service'
export default {
  props: {
    businessCode: Number,
    templateId: Number,
  },
  data () {
    return {
      info: null
    }
  },
  mounted () {
    setTimeout(() => {
      this.getDetail()
    }, 500)

  },
  methods: {
    getDetail () {
      // 获取详情
      let _loading = this.$loading({ fullscreen: true })
      _approval.getByBusinessCodeTaskList({
        businessCode: this.businessCode,
        templateId: this.templateId
      }, response => {
        this.info = response
        _loading.close()
      }, () => {
        _loading.close()
      })
    }
  }
}
</script>

<style scoped>
.wapper {
  width: 100%;
  height: 100%;
  padding: 15px;
}
.approval-btn {
  position: fixed;
  padding: 30px;
  bottom: 0;
  right: 0;
  width: calc(100% - 350px);
  border-top: 1px solid #00a862;
  background: #fff;
}
.approval-btn .opinion {
  margin-bottom: 30px;
  width: 350px;
}
.approval-btn a {
  display: inline-block;
  padding: 10px 70px;
  margin-right: 15px;
  border-radius: 7px;
  font-weight: bold;
  text-align: center;
}
.ok-btn {
  background: #00a862;
  color: #fff;
}
.reject-btn {
  background: #f8d1b8;
  color: #e6a23c;
}
.approval-wapper .opinion {
  color: #9da2a9;
  display: block;
  max-width: 160px;
}
.approval-wapper .title {
  font-size: 25px;
  font-weight: lighter;
  border-bottom: 1px solid #00a862;
  display: block;
}
.approval-wapper .approval-main {
  padding: 30px;
  position: relative;
}
.approval-wapper .approval-main::before {
  content: "";
  height: calc(100% - 65px);
  width: 1px;
  border-left: 1px dashed #bbbfc1;
  position: absolute;
  top: 65px;
  left: 60px;
}
.approval-wapper .approval-main::after {
  content: "";
  height: 30px;
  width: 1px;
  border-left: 1px dashed #bbbfc1;
  position: absolute;
  top: 2px;
  left: 60px;
}
.approval-wapper .approval-main:first-child::after {
  display: none;
}
.approval-wapper .approval-main:last-child::before {
  display: none;
}
.approval-item span {
  vertical-align: top;
}
.approval-method {
  color: #00a862;
  font-size: 12px;
  border: 1px solid #00a862;
  border-radius: 2px;
  margin-left: 5px;
}
.approval-wapper .approval-item {
  display: inline-block;
  margin-left: 15px;
  vertical-align: top;
}
.approval-item .approval-content {
  display: inline-block;
  margin-left: 15px;
  vertical-align: top;
}
.approval-wapper .time {
  color: #bbbfc1;
  display: block;
  font-size: 12px;
}
.approval-wapper .state {
  text-align: right;
  position: absolute;
  right: 0;
}
.approval-wapper .icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #00a862;
}
.approval-detail .avatar {
  width: 30px;
  height: 30px;
  border: 1px solid #2c2c2c;
  border-radius: 2px;
}
.approval-detail li {
  display: block;
  padding: 10px 0;
  width: 350px;
  position: relative;
}
.approval-detail div {
  display: inline-block;
  margin-left: 10px;
  vertical-align: top;
}
</style>